// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.print-cancelview {
    margin-left: 10px;
}

.prntdiv {
    padding: 10px;
}

.mr-10 P {
    width: 100px;
}

/* :host ::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {
    padding: 1em 0 0.65em 0;
} */

@media screen and (max-width: 365px) {
    .matfields {
        max-width: 58% !important;
    }

    .mat-form-field {
        width: 100% !important;
    }

    .mr-10 P {
        width: 95px !important;
    }
}

.mid-button {
    border: 1px solid #ccc !important;
    box-shadow: 0px 20px 60px rgb(0 0 0 / 5%) !important;
    border-radius: 12px !important;
}
`, "",{"version":3,"sources":["webpack://./projects/lib-map-common/src/lib/analysis-print-map/analysis-print-map.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;;GAEG;;AAEH;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,iCAAiC;IACjC,oDAAoD;IACpD,8BAA8B;AAClC","sourcesContent":[".print-cancelview {\n    margin-left: 10px;\n}\n\n.prntdiv {\n    padding: 10px;\n}\n\n.mr-10 P {\n    width: 100px;\n}\n\n/* :host ::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {\n    padding: 1em 0 0.65em 0;\n} */\n\n@media screen and (max-width: 365px) {\n    .matfields {\n        max-width: 58% !important;\n    }\n\n    .mat-form-field {\n        width: 100% !important;\n    }\n\n    .mr-10 P {\n        width: 95px !important;\n    }\n}\n\n.mid-button {\n    border: 1px solid #ccc !important;\n    box-shadow: 0px 20px 60px rgb(0 0 0 / 5%) !important;\n    border-radius: 12px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
